import { request } from './api';
import type { SystemRole } from './adminAuth';
export type ProjectAccess={id:string;name:string;role:string;actions:string[];mcp_allowed:boolean};
export type AccessMe={user_id:string;system_admin:boolean;projects:ProjectAccess[];personal_mcp_keys_enabled:boolean};
export type ProjectMember={user_id:string;display_name:string;role:'owner'|'tester'|'researcher';active:boolean;account_active:boolean;system_role:SystemRole;can_execute:boolean};
export type AccessUser={id:string;display_name:string;role:SystemRole;active:boolean};
export type PersonalKey={id:string;name:string;prefix:string;project_ids:string[];scopes:string[];active:boolean;expires_at:string;created_at:string};
export const scopes=[
 {value:'vuilabs:read',action:'read',label:'查看统计与元数据'},
 {value:'vuilabs:content',action:'content',label:'读取文本和音频'},
 {value:'vuilabs:compare',action:'compare',label:'创建版本对比'},
 {value:'vuilabs:review',action:'review',label:'管理验收与听审'},
 {value:'vuilabs:batch',action:'execute',label:'执行计费批测'},
 {value:'vuilabs:export',action:'export',label:'导出数据'},
];
export function availableScopes(projects:ProjectAccess[],ids:string[]){
 const selected=ids.map(id=>projects.find(p=>p.id===id));
 if(!selected.length||selected.some(p=>!p||!p.mcp_allowed))return [];
 return scopes.filter(s=>selected.every(p=>p!.actions.includes(s.action)));
}
export function memberChange(member:ProjectMember,active:boolean,canExecute:boolean){
 return {role:member.role,active,can_execute:canExecute};
}
export const getAccessMe=()=>request<AccessMe>('/api/v1/platform/access/me');
export const accessBase='/api/v1/platform/access';

export function keyStatus(key:PersonalKey,projects:ProjectAccess[],now=Date.now()){
 if(!key.active)return '已撤销';
 if(!Number.isFinite(Date.parse(key.expires_at)))return '有效期异常';
 if(Date.parse(key.expires_at)<=now)return '已到期';
 const allowed=availableScopes(projects,key.project_ids).map(s=>s.value);
 return key.scopes.every(s=>allowed.includes(s))?'有效':'授权已失效';
}

export function accessMessage(error:unknown){
 const text=error instanceof Error?error.message:'操作失败，请重试';
 const messages:Record<string,string>={last_project_owner_required:'请先指定另一位有效项目负责人，再移除或调整该成员。',role_membership_conflict:'项目角色不能超出账号角色范围。',ambiguous_account_name_use_id:'存在同名账号，请改用账号 ID 查找。',project_access_denied:'你已没有这个项目的访问权限，请刷新页面。',credential_grants_denied:'所选授权已变化，请刷新后重新选择项目和操作。',personal_mcp_unavailable:'个人 MCP 凭证尚未开放。'};
 return Object.entries(messages).find(([code])=>text.includes(code))?.[1]??text;
}

export function restrictKeyScopes(projects:ProjectAccess[],ids:string[],previous:string[]){
 const allowed=availableScopes(projects,ids).map(s=>s.value);
 if(!allowed.includes('vuilabs:read'))return [];
 return [...new Set(['vuilabs:read',...previous.filter(s=>allowed.includes(s))])];
}
